let scrollY = 0;

export const lockBodyScroll = () => {
  if (typeof window === 'undefined') return;

  scrollY = window.scrollY || window.pageYOffset;

  // Apply styles to body to lock scroll
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
  document.body.style.overflow = 'hidden';
};

export const unlockBodyScroll = () => {
  if (typeof window === 'undefined') return;

  // Remove styles
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.style.overflow = '';

  // Restore scroll position
  window.scrollTo(0, scrollY);
};
